module.exports = __webpack_public_path__ + "static/img/u855.97fa4a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u855.svg
// module id = M15G
// module chunks = 209